import { WebsiteWhatsAppCtaSlot } from 'src/api/generated';
import type { TranslationKey } from 'src/modules/shared/types/i18n/translation-keys.type';

/** Editable WhatsApp call to action of the public site. */
export interface WebsiteWhatsAppCtaConfig {
  /** Slot where the site shows the call to action. */
  slot: WebsiteWhatsAppCtaSlot;
  /** Translation key of the slot name. */
  labelKey: TranslationKey;
  /** Translation key of the default message. */
  defaultMessageKey: TranslationKey;
}

/** WhatsApp calls to action the agency can customize, in display order. */
export const WEBSITE_WHATSAPP_CTA_CONFIGS: readonly WebsiteWhatsAppCtaConfig[] =
  [
    {
      slot: WebsiteWhatsAppCtaSlot.GENERAL_CONTACT,
      labelKey: 'websites.settings.whatsApp.cta.generalContact.label',
      defaultMessageKey:
        'websites.settings.whatsApp.cta.generalContact.defaultMessage',
    },
    {
      slot: WebsiteWhatsAppCtaSlot.PROPERTY_CARD,
      labelKey: 'websites.settings.whatsApp.cta.propertyCard.label',
      defaultMessageKey:
        'websites.settings.whatsApp.cta.propertyCard.defaultMessage',
    },
    {
      slot: WebsiteWhatsAppCtaSlot.PROPERTY_DETAIL,
      labelKey: 'websites.settings.whatsApp.cta.propertyDetail.label',
      defaultMessageKey:
        'websites.settings.whatsApp.cta.propertyDetail.defaultMessage',
    },
    {
      slot: WebsiteWhatsAppCtaSlot.SCHEDULE_VISIT,
      labelKey: 'websites.settings.whatsApp.cta.scheduleVisit.label',
      defaultMessageKey:
        'websites.settings.whatsApp.cta.scheduleVisit.defaultMessage',
    },
  ];
